function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function Delete(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M7.5 6V4.5A2.5 2.5 0 0110 2h4a2.5 2.5 0 012.5 2.5V6h4a.5.5 0 010 1h-17a.5.5 0 010-1h4zm1-1.5A1.5 1.5 0 0110 3h4a1.5 1.5 0 011.5 1.5V6h-7V4.5z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 8a.5.5 0 01.536.462l.826 11.149A1.5 1.5 0 007.857 21h8.286a1.5 1.5 0 001.496-1.39l.826-11.148a.5.5 0 01.997.074l-.826 11.149A2.5 2.5 0 0116.143 22H7.857a2.5 2.5 0 01-2.493-2.315l-.826-11.15A.5.5 0 015 8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.5 10a.5.5 0 01.5.5v8a.5.5 0 01-1 0v-8a.5.5 0 01.5-.5zM14 10.5a.5.5 0 011 0v8a.5.5 0 01-1 0v-8z"
  }));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(Delete);
export default ForwardRef;